import Vue from 'vue';
window.Vue = Vue;

const vueContainer = document.querySelector('#vue');

if (vueContainer) {
  // Vue.component(
  //   'modal-window-component',
  //   require('./components/ModalWindowComponent.vue').default
  // );
  Vue.component(
    'preview-image-component',
    require('./components/PreviewInputImageComponent.vue').default
  );
  Vue.component(
    'license-selecter-component',
    require('./components/LicenseSelecterComponent.vue').default
  );
  Vue.component(
    'user-suggest-input-component',
    require('./components/UserSuggesInputComponent.vue').default
  );

  new Vue({
    el: '#vue',
  });
}
